import {useEffect} from 'react'
import { useLocation } from 'react-router-dom'
// import { reactPlugin } from '../../../app/AppInsight'
import { usePageViews } from '../../../app/UsePageView'
const ScrollTop = () => {
    const {pathname} = useLocation()
  usePageViews();
    useEffect(() => {
        window.scroll(0,0)
        // reactPlugin.trackPageView({ name: `${pathname} page` });
    },[pathname])
  return null
}

export default ScrollTop